










































































// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Components
import Modal, { ModalTitleColor } from '@/shared/components/Modal.component.vue';
import Btn, { BtnColor, BtnWidth, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import Input, { InputStyle } from '@/shared/components/input.component.vue';

// Constants
import Assets from '@/constants/assets.ts';
import RouteNames from '@/constants/route-names';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';

// Services
import ClientService from '@/manager/client/client.service';

@Component({
    components: {
        Btn,
        Input,
        Modal,
    },
    computed: {
        ...mapGetters({
            getClient: 'getClient',
        }),
    },
})
export default class ClientModal extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop() private convocationId!: string;
    @Prop() private userId!: string;
    @Prop() private openModal!: boolean;
    @Prop({ default: true }) private showNewClientBtn!: boolean;


    private assets = Assets;
    private getClient !: any;
    private modalTitleColor = ModalTitleColor;
    private btnColor = BtnColor;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private btnWidth = BtnWidth;
    private inputStyle = InputStyle;
    private checkingEmail = false;
    private email = '';


    get client() {
        return this.getClient(this.userId);
    }

    get participantFullName() {
        let fullName = '';
        if ( this.client ) {
            fullName = this.client.user.fullName;
        }
        return fullName;
    }

    get participantEmail() {
        let email = '';
        if ( this.client ) {
            email = this.client.user.email;
        }
        return email;
    }

    get modalTitle() {
        let title = 'Este cliente ya existe';
        if ( this.checkingEmail ) {
            title = 'Introduce el email del cliente';
        }
        return title;
    }

    get modalSubtitle() {
        let subtitle = 'Confirma que la compra es para este cliente';
        if ( this.checkingEmail ) {
            subtitle = '';
        }
        return subtitle;
    }


    private confirmBtnClicked() {
        this.$emit('confirm');
    }

    private goToCheckingEmailForm() {
        this.checkingEmail = true;
    }

    private closeModal() {
        this.$emit('close-modal', () => {
            this.checkingEmail = false;
        });
    }

    private setFormError(err: any) {
        const serverError = err.response.data;
        this.error = { ...serverError };
    }

    private checkEmail() {
        ClientService.isEmailInUse(this.email).then(
            (res) => {
                // TODO delete participant
                this.$emit('new-client', this.email);
            },
            (err) => {
                this.setFormError(err);
            },
        );
    }

}
